const SpotifyIcon = (): JSX.Element => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_5903_136712)">
			<path
				d="M12 0C5.37581 0 0 5.37581 0 12C0 18.6242 5.37581 24 12 24C18.6242 24 24 18.6242 24 12C24 5.37581 18.6242 0 12 0Z"
				fill="#1ED760"
			/>
			<path
				d="M19.6738 10.795C19.4222 10.795 19.2673 10.7321 19.0496 10.6063C15.6044 8.54981 9.44477 8.05629 5.45767 9.16917C5.28348 9.21757 5.06573 9.29501 4.83348 9.29501C4.19477 9.29501 3.70605 8.79661 3.70605 8.15301C3.70605 7.49498 4.11251 7.1224 4.54799 6.99659C6.25121 6.4982 8.15765 6.26111 10.2335 6.26111C13.7657 6.26111 17.4673 6.99659 20.1722 8.57397C20.5496 8.79173 20.7964 9.09173 20.7964 9.66757C20.7964 10.3257 20.2641 10.795 19.6738 10.795ZM18.1738 14.4821C17.9222 14.4821 17.7528 14.3708 17.5786 14.2789C14.5544 12.4885 10.0448 11.7676 6.03348 12.8563C5.80121 12.9192 5.67541 12.9821 5.45767 12.9821C4.93993 12.9821 4.51896 12.5611 4.51896 12.0433C4.51896 11.5257 4.77057 11.1821 5.26896 11.0417C6.61412 10.6643 7.98832 10.3837 10.0012 10.3837C13.1416 10.3837 16.1754 11.1627 18.5657 12.5853C18.9576 12.8176 19.1125 13.1176 19.1125 13.5385C19.1076 14.0611 18.7012 14.4821 18.1738 14.4821ZM16.8722 17.6563C16.6689 17.6563 16.5432 17.5933 16.3544 17.4821C13.3351 15.6627 9.82221 15.5853 6.35283 16.2966C6.16412 16.345 5.91735 16.4224 5.77702 16.4224C5.30767 16.4224 5.01251 16.0498 5.01251 15.6579C5.01251 15.1595 5.30767 14.9224 5.67057 14.845C9.63349 13.9692 13.6835 14.0466 17.1383 16.1127C17.4335 16.3014 17.6076 16.4708 17.6076 16.9111C17.6076 17.3514 17.2641 17.6563 16.8722 17.6563Z"
				fill="black"
			/>
		</g>
		<defs>
			<clipPath id="clip0_5903_136712">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
)

export default SpotifyIcon
